import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("gr_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  try {
    const op = JSON.parse(localStorage.getItem("gr_firma_op") || "null");
    if (op && op.id) cfg.headers["X-Operatore-Id"] = op.id;
  } catch { /* ignore */ }
  return cfg;
});

export default api;

export const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(v.length <= 10 ? v + "T00:00:00" : v);
  if (isNaN(d)) return v;
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
};
export const fmtEur = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(v || 0));
export const fmtQual = (q) => {
  if (!q) return "";
  return String(q).trim().split(/\s+/).map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
};
export const calcEta = (dob) => {
  if (!dob) return "";
  const d = new Date(dob);
  return Math.floor((Date.now() - d) / (365.25 * 24 * 3600 * 1000));
};
